import { useState } from "react";
import { IconClock, IconCheck } from "@tabler/icons-react";
import styles from "../../../../pages/ClientDashboard/Profile/profile.module.css";
import Input from "../../FormInput/input";
import Toggle from "../../Toggle/Toggle";
import Button from "../../Button/button";


export default function QuietHoursCard() {
  const [from, setFrom] = useState("22:00");
  const [to, setTo] = useState("08:00");

  return (
    <div className={styles.card}>
      <div className={styles.cardHeader}>
        <div className={styles.cardHeaderLeft}>
          <div className={styles.cardIcon}>
            <IconClock size={18} />
          </div>
          <div>
            <div className={styles.cardTitle}>Quiet Hours</div>
          </div>
        </div>
      </div>
      <div className={styles.cardBody}>
        <p className={styles.quietHoursIntro}>
          Pause all non-critical notifications during these hours.
        </p>
        <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
          <Input
            label="From"
            id="quietFrom"
            type="time"
            value={from}
            onChange={(e) => setFrom(e.target.value)}
          />
          <Input
            label="To"
            id="quietTo"
            type="time"
            value={to}
            onChange={(e) => setTo(e.target.value)}
          />
        </div>
        <div className={styles.quietHoursToggleRow}>
          <span className={styles.quietHoursToggleLabel}>
            Enable Quiet Hours
          </span>
          <Toggle
            id="quietHoursEnabled"
            ariaLabel="Enable Quiet Hours"
            defaultChecked
          />
        </div>
        <Button
          variant="secondary"
          leftIcon={<IconCheck size={15} />}
          fullWidth
          style={{ marginTop: 14 }}
        >
          Save Preferences
        </Button>
      </div>
    </div>
  );
}
